import { createAnalyticsState, getActiveDateIntervalName } from 'components/Dashboard/Analytics/createAnalyticsState';
import thousandCommas from 'components/Dashboard/helpers/thousandCommas';
import StakeholderSentimentChangesGraph from 'components/Dashboard/StakeHolders/StakeholderPage/ui/ActivitySections/StakeholderSentimentChangesGraph';
import StakeholderSentimentRightPanel from 'components/Dashboard/StakeHolders/StakeholderPage/ui/ActivitySections/StakeholderSentimentRightPanel';
import StakeholderSentimentSnapshotGraph from 'components/Dashboard/StakeHolders/StakeholderPage/ui/ActivitySections/StakeholderSentimentSnapshotGraph';
import getUrlParam from 'components/Dashboard/utilities/getUrlParam';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

const StakeholderSentimentSection = (props) => {
  const { StakeholderInformation, scrollBarRef, sentimentSnapshotState } = props;
  const { name, categories } = StakeholderInformation;
  const specialAdviser = categories?.includes('Special Adviser');

  const [dataSentimentChanges, setDataSentimentChanges] = useState({});
  const [isLoadingSentimentChanges, setIsLoadingSentimentChanges] = useState(true);
  const [rightPanelState, setRightPanelState] = useState({ open: false });
  const [sentimentChangesAnalyticsState, setSentimentChangesAnalyticsState] = useState(createAnalyticsState());

  const { data, noSearchCondition, isLoading, sentimentSnapshotAnalyticsState } = sentimentSnapshotState ?? {};
  const { labels } = data;
  const { sentimentSnapshotAnalytics } = sentimentSnapshotAnalyticsState ?? {};

  const emptyMessage = data?.value?.filter((item) => item > 0).length === 0;
  const mentionsDataSection = useRef(null);

  const topicParameter = getUrlParam('topic-id');
  const searchParameter = getUrlParam('search');

  const params = useParams();
  const { id } = params;

  const createSnapshotTextValue = (item) => {
    const index = typeof item === 'string' ? labels?.indexOf(item) : item?.[0]?.index;
    const sentiment = labels[index];
    const value = data?.value[index];
    const totalValue = data?.value.reduce(
      (previousValue, currentValue) => previousValue + (typeof currentValue === 'number' ? currentValue : 0),
      0
    );
    const percentage = (value * 100) / totalValue;
    const daysPhrase = getActiveDateIntervalName(sentimentSnapshotAnalytics?.sentimentDateInterval, 'last year');
    let text = `${value ? thousandCommas(value) : 0} of ${thousandCommas(totalValue)} ${`contribution${
      totalValue === 1 ? '' : 's'
    } (${Math.round(percentage ?? 0)}%) by ${name}`} in the ${daysPhrase} were ${sentiment.toLowerCase()}`;
    if (value === 0) {
      text = `No contributions by ${name} in the ${daysPhrase} were ${sentiment.toLowerCase()}`;
    }
    return text;
  };

  useEffect(() => {
    //AE: Necessary when changing topics to prevent showing results from previous topic
    setRightPanelState({ open: false });
  }, [topicParameter, searchParameter, isLoadingSentimentChanges, isLoading]);

  return (
    <>
      {noSearchCondition ? (
        <p className='text-center title-h5 light-70-text mx-auto' style={{ paddingTop: '24vh', maxWidth: '360px' }}>
          {specialAdviser
            ? 'Sentiment is not available for Special Advisers'
            : <>To see stakeholder sentiment, select a <span className='font-weight-bold'>specific topic</span> or do a <span className='font-weight-bold'>keyword search</span> in the dropdown above</>}
        </p>
      ) : (
        <>
          <div className='px-4 px-lg-5 pb-4'>
            <StakeholderSentimentSnapshotGraph
              StakeholderInformation={StakeholderInformation}
              sentimentSnapshotState={sentimentSnapshotState}
              setRightPanelState={setRightPanelState}
              createSnapshotTextValue={createSnapshotTextValue}
              sentimentSnapshotAnalyticsState={sentimentSnapshotAnalyticsState}
            />
            <StakeholderSentimentChangesGraph
              sentimentChangesState={{ dataSentimentChanges, setDataSentimentChanges }}
              noSearchCondition={noSearchCondition}
              loadingSentimentChangesState={{
                isLoading: isLoadingSentimentChanges,
                setIsLoading: setIsLoadingSentimentChanges,
              }}
              StakeholderInformation={StakeholderInformation}
              stateSentimentChangesAnalytics={{ sentimentChangesAnalyticsState, setSentimentChangesAnalyticsState }}
              setRightPanelState={setRightPanelState}
            />
            {rightPanelState.open && !isLoading && !emptyMessage && (
              <div className='pt-4' ref={mentionsDataSection}>
                <>
                  <StakeholderSentimentRightPanel
                    contentState={rightPanelState}
                    analyticsState={
                      rightPanelState?.type === 'SentimentChanges'
                        ? sentimentChangesAnalyticsState
                        : sentimentSnapshotAnalytics
                    }
                    stakeholderId={id}
                    refs={{ scrollBarRef, mentionsDataSection }}
                    setRightPanelState={setRightPanelState}
                    StakeholderInformation={StakeholderInformation}
                    createSnapshotTextValue={createSnapshotTextValue}
                  />
                </>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default StakeholderSentimentSection;
